import {
  FINANCE_ALL,
  FINANCE_GET,
  FINANCE_POST,
  FINANCE_PUT,
  FINANCE_DEL,
  FINANCE_LOADING,
  FINANCE_ERROR,
} from '../../actions/types';

const initialState = {
  finance: null,
  isLoading: true,
  isCompleted: true,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case FINANCE_LOADING:
      return { isLoading: true, isCompleted: true };
    case FINANCE_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case FINANCE_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case FINANCE_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case FINANCE_POST:
      return { isLoading: false, isCompleted: true };
    case FINANCE_PUT:
      return { isLoading: false, isCompleted: true };
    case FINANCE_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
